module.exports = __webpack_public_path__ + "img/user-profile.7f0c927e.svg";